import { render, staticRenderFns } from "./VenueHireTable.vue?vue&type=template&id=56b65915&scoped=true"
import script from "./VenueHireTable.vue?vue&type=script&lang=js"
export * from "./VenueHireTable.vue?vue&type=script&lang=js"
import style0 from "./VenueHireTable.vue?vue&type=style&index=0&id=56b65915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b65915",
  null
  
)

export default component.exports